import { Controller } from "@hotwired/stimulus"
import "@selectize/selectize"

export default class extends Controller {
  connect() {
    this.initializeSelectizedSelects()
  }

  disconnect() {
    // Destroy the Selectize element to avoid duplication of the field
    if (this.selectizeElement.length > 0) {
      this.selectizeElement[0].selectize.destroy()
    }
  }

  initializeSelectizedSelects() {
    this.selectizeElement = $(".selectize").selectize({
      onInitialize: function () {
        $(this.$wrapper)[0].style.visibility = "visible"
      },
      onChange: function (value) {
        // Special case for the leads-imports/new page, where the selection of a new
        // list must trigger the display of a special input
        if (window.location.pathname === "/leads-imports/new") {
          if (value === "new_list") {
            $("#leads-list-field").val("")
            $("#new-list-name").slideDown()
          } else {
            $("#new-list-name").slideUp()
          }
        }

        return
      },
    })
  }
}
